'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const WeeklyActivityChart = dynamic(() => import('./WeeklyActivityChart'), { ssr: false });
const CourseCompletionChart = dynamic(() => import('./CourseCompletionChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <div className="xl:col-span-2 card p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-base font-semibold text-foreground">Weekly Learning Activity</h2>
            <p className="text-xs text-muted-foreground mt-0.5">Minutes spent per day this week</p>
          </div>
          <select className="text-xs border border-border rounded-lg px-2.5 py-1.5 text-muted-foreground bg-card focus:outline-none focus:ring-1 focus:ring-ring">
            <option>This week</option>
            <option>Last week</option>
            <option>This month</option>
          </select>
        </div>
        <WeeklyActivityChart />
      </div>

      <div className="card p-5">
        <div className="mb-4">
          <h2 className="text-base font-semibold text-foreground">Course Progress</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Completion across active enrollments</p>
        </div>
        <CourseCompletionChart />
      </div>
    </div>
  );
}